import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import companyAxios from '../../axios/company'

export const fetchCompanies = filterOptions => {
  return dispatch => {
    const params = {
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10,
      company_id: filterOptions ? filterOptions.company_id : null
    }
    dispatch(fetchCompaniesStart())
    companyAxios
      .get(filterOptions ? filterOptions.recordId : '', {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: +per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchCompaniesSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchCompaniesFailed(error))
      })
  }
}

export const fetchCompaniesStart = () => {
  return {
    type: actionTypes.FETCH_COMPANY_START
  }
}

export const fetchCompaniesSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_COMPANY_SUCCESS,
    pagination,
    records
  }
}

export const fetchCompaniesFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchCompanyById = recordId => {
  return dispatch => {
    dispatch(fetchCompaniesStart())
    companyAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCompanyByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCompaniesFailed(error))
      })
  }
}

export const fetchCompanyByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_COMPANY_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedCompanyRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_COMPANY_RECORD
  }
}

export const createCompany = (recordData, page) => {
  return dispatch => {
    dispatch(createCompanyStart())

    companyAxios
      .post('', recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Company Created',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(createCompanySuccess())
        dispatch(fetchCompanies(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Company field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createCompanyFailed())
      })
  }
}

export const createCompanyStart = () => {
  return {
    type: actionTypes.CREATE_COMPANY_START
  }
}

export const createCompanySuccess = () => {
  return {
    type: actionTypes.CREATE_COMPANY_SUCCESS
  }
}

export const createCompanyFailed = () => {
  return {
    type: actionTypes.CREATE_COMPANY_FAILED
  }
}

export const updateCompany = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateCompanyStart())
    companyAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Company Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateCompanySuccess())
        dispatch(fetchCompanies(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Invalid company field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
          })
        )
        dispatch(updateCompanyFailed())
      })
  }
}

export const updateCompanyStart = () => {
  return {
    type: actionTypes.UPDATE_COMPANY_START
  }
}

export const updateCompanySuccess = () => {
  return {
    type: actionTypes.UPDATE_COMPANY_SUCCESS
  }
}

export const updateCompanyFailed = () => {
  return {
    type: actionTypes.UPDATE_COMPANY_FAILED
  }
}

export const deleteCompany = (recordId, page) => {
  return dispatch => {
    dispatch(deleteCompanyStart())
    companyAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Company Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteCompanySuccess())
        dispatch(fetchCompanies(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteCompanyFailed())
      })
  }
}

export const deleteCompanyStart = () => {
  return {
    type: actionTypes.DELETE_COMPANY_START
  }
}

export const deleteCompanySuccess = message => {
  return {
    type: actionTypes.DELETE_COMPANY_SUCCESS,
    message
  }
}

export const deleteCompanyFailed = errorMessage => {
  return {
    type: actionTypes.DELETE_COMPANY_FAILED,
    errorMessage
  }
}
